module.exports = __webpack_public_path__ + "ai.svg?22727512fe0373e1aefee8429d3ced54";